import { Component, Vue } from 'vue-facing-decorator';;
import { useCookies } from "vue3-cookies";
import AuthService from '@/services/AuthService';
import { ElMessage, ElNotification } from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';

@Component(
{
    components:
    {
        User,
        Lock,
        Header
    },
})

export default class Login extends Vue 
{
    private environmentVersion = '';
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;

    private loading: boolean = false;
    private showLogin : boolean = false;
    private showButton: boolean = false;
    private failCount : number = 0;
    private userModel : UserModel | undefined = {} as UserModel;

    public async mounted()
    {
        this.environmentVersion = process.env.VUE_APP_VERSION;
        this.showLogin = true;
    }

    public async onLoginClick()
    {
        this.loading = true;
        
        if (this.userModel && this.userModel.username && this.userModel.password)
        {
            let user:UserModel | undefined = await AuthService.login(this.userModel!.username, this.userModel!.password);

            if (user && user.userid > 0)
            {
                this.$router.push('/verify');
            }
            else
            {
                this.failCount++;
                ElNotification(
                {
                    title: 'Anmeldung ist fehlgeschlagen',
                    message: 'Der Benutzername oder das Passwort ist ungültig.',
                    type: 'error',
                });
            }
        }

        this.loading = false;
    }

    public async onInput()
    {
        this.showButton = (this.userModel.username && this.userModel.username.length > 0 && this.userModel.password && this.userModel.password.length > 0);
    }

    public async onResetClick()
    {
        //this.$router.push(`/reset/password`);
    }
};

